import { IRequesterInfo } from '../../../../../base/models/proxyModels'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { PreOrderAddProductRequest } from '../models/models'
export class AddProductPreOrderApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({ url: 'admin/preOrder/addProductToPreOrder', requesterInfo })
  }

  public async addProduct(request: PreOrderAddProductRequest): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
